import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import {
  BaseComponent, QueryService, SearchService, TitleService, TestResult_PatientsByFacilityAssayRow,
  PatientsFacilityAssayComponent, ReportKeys, FilterService
} from '../../core';
import { NgxMatToastService } from 'ngx-mat-toast';
import { TranslateService } from '@ngx-translate/core';
import { GoogleAnalyticsService } from '../../core/services/google-analytics.service';
import { translate } from 'src/app/core/utils/translateServiceHelper';

@Component({
  selector: 'app-report-patient-facility-assay',
  templateUrl: './report-patient-facility-assay.component.html',
  styleUrls: ['./report-patient-facility-assay.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ReportPatientFacilityAssayComponent extends BaseComponent implements OnInit, OnDestroy {
  @ViewChild('chart', { static: true }) private patientsByFacilityAssay: PatientsFacilityAssayComponent;

  constructor(private queryService: QueryService,
    private searchService: SearchService,
    private titleService: TitleService,
    private filterService: FilterService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private toastr: NgxMatToastService,
    private translate: TranslateService) {
    super();
  }


  ngOnInit(): void {

    this.subscription.add(this.queryService.filtersApplied.subscribe((filtersApplied: boolean) => {
      console.debug(`Filters applied: ${filtersApplied}`);
    }));

    this.subscription.add(this.queryService.searchRequested.subscribe(() => {
      this.onSearch();
    }));

    this.onSearch();

    this.titleService.updateTitleTranslateKey('ReportMenu.PatientsByFacilityAssay');
  }

  onSearch(): void {
    if (this.filterService.isReportEnabled(ReportKeys.PatientsByFacilityAssay)) {
      this.googleAnalyticsService.logWithLabels('View Report', 'Report', 'View Patient By Facility/Assay Report', 'filters', this.queryService.getCurrentQuery(true));
      this.subscription.add(this.searchService.getReportPatientsByFacilityAssay(this.queryService.getCurrentQuery(true)).subscribe(
        (result: TestResult_PatientsByFacilityAssayRow[]) => {
          if (!result || result.length === 0) {
            const title = translate(this.translate, 'ReportMenu.NoDataToShow');
            this.toastr.info(title);
            return;
          }

          this.patientsByFacilityAssay.setData(result);
        }));
    } else {
      const message = translate(this.translate, 'ReportMenu.RequirePatientOrg');
      const title = translate(this.translate, 'ReportMenu.ReportLoadError');
      this.toastr.error(message, title);
    }
  }

  ngOnDestroyInternal(): void {
    // Required by base component
  }

  savePDF(): void {
    this.patientsByFacilityAssay.saveAsPdf();
  }

  saveImage(): void {
    this.patientsByFacilityAssay.saveAsImage();
  }

}
